import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeMusicToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeMusicToAppleMusic}
            sections={<PairTransferGuideContent sourceKey="youtubeMusic" destKey="appleMusic" />}
        />
    );
}
